/*
 * $Id:: filterItems.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

const IP_RIGHT_TYPE = ['All IP types', 'Trademarks', 'Designs', 'PATENTS'];

const filters = {
    drafts: {
        trademark: [
            {
                globalsKey: 'requestNames',
                filterid: 'requestNames',
                name: 'requestNames',
                placeholder: 'request.name',
                filterOptions: [],
                multiple: true,
            },
            {
                globalsKey: 'modalities',
                filterid: 'modality',
                name: 'modality',
                placeholder: 'modality',
                filterOptions: [],
                multiple: true,
            },
            {
                filterid: 'dateIntervalDraft',
                name: 'dates',
                placeholder: 'date',
            },
        ],
        design: [
            {
                globalsKey: 'requestNames',
                filterid: 'requestNames',
                name: 'requestNames',
                placeholder: 'request.name',
                filterOptions: [],
                multiple: true,
            },
            {
                globalsKey: 'modalities',
                filterid: 'modality',
                name: 'modality',
                placeholder: 'modality',
                filterOptions: [],
                multiple: true,
            },
            {
                filterid: 'dateIntervalDraft',
                name: 'dates',
                placeholder: 'date',
            },
        ],
        patents: [
            {
                globalsKey: 'requestNames',
                filterid: 'requestNames',
                name: 'requestNames',
                placeholder: 'request.name',
                filterOptions: [],
                multiple: true,
            },
            {
                globalsKey: 'modalities',
                filterid: 'modality',
                name: 'modality',
                placeholder: 'modality',
                filterOptions: [],
                multiple: true,
            },
            {
                filterid: 'dateIntervalDraft',
                name: 'dates',
                placeholder: 'date',
            },
        ],
    },
};

const trademarksActionOptions = [
    'TM Renewal',
    'TM Transfer',
    'TM Change Owner Details',
    'TM Change Rep/Corr details',
    'TM Generic',
    'TM License Contract',
    'TM Rights in rem',
];

const initiateActions = {
    drafts: {
        trademarks: trademarksActionOptions,
        designs: [...trademarksActionOptions, 'TM Withdrawal/Surrender', 'TM Limit G&S'],
    },
};

const getInitiateActions = (category) => initiateActions.drafts[category] || [];

const getDropDownFilters = (category) => filters.drafts[category] || [];

export default {
    getDropDownFilters,
    getInitiateActions,
};
